import { useTheme } from '@mui/material';
import cn from 'classnames';
import { useCallback, useMemo } from 'react';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Drawer } from '..';
import useWindowSize from '../../hooks/useWindowSize';
import { toggleUiElement } from '../../store/actions/shell';
import { selectIs2FADrawerShown } from '../../store/selectors/shell';
import { DrawerAnimationDirectionEnum } from '../../types/shell';

import styles from './TwoFaSidebar.module.scss';

interface IChildProps {
  onClose: () => void;
}

interface IProps {
  children?: (childProps: IChildProps) => React.ReactNode;
}

const TwoFaSidebar = ({ children }: IProps) => {
  const dispatch = useDispatch();

  const { sass: variables } = useTheme();
  const { mobile, HD } = useWindowSize();

  const trigger = useSelector(selectIs2FADrawerShown);

  const from = useMemo(() => (mobile ? variables.orgSidebarMinHeight : variables.orgSidebarMinWidth), [mobile]);
  const to = useMemo(() => {
    if (mobile) {
      return variables.orgSidebarMaxHeight;
    }

    if (HD) {
      return variables.orgSidebarMaxWidthHD;
    }

    return variables.orgSidebarMaxWidthFullHD;
  }, [mobile, HD]);

  const handleClose = useCallback(() => {
    dispatch(toggleUiElement({ twoFASidenavIsShown: false }));
  }, []);

  return (
    <Drawer
      className={cn(styles.container)}
      direction={mobile ? DrawerAnimationDirectionEnum.Vertically : DrawerAnimationDirectionEnum.Horizontally}
      from={from}
      to={to}
      trigger={trigger}
      onClose={handleClose}
      withOverlay
      overlayClassName={styles.overlay}
    >
      {trigger && children?.({ onClose: handleClose })}
    </Drawer>
  );
};

export default TwoFaSidebar;
